import { combineReducers } from "redux";

// CUSTOM REDUCERS
import * as auth from "./reducers/AuthReducer";
import * as NodeOperation from "./reducers/NodeOperation";
import * as authstate from "./reducers/AuthStateReducer";
import * as metadata from "./reducers/MetaDataReducer";
import * as clientdata from "./reducers/ClientDataReducer";
import * as refreshstatedata from "./reducers/RefreshDataReducer";

// COMBINING REDUCERS
export const rootReducer = combineReducers({
  auth: auth.reducer,
  NodeOperation: NodeOperation.reducer,
  authstate: authstate.reducer,
  metadata: metadata.reducer,
  clientdata: clientdata.reducer,
  refreshstate: refreshstatedata.reducer,
});
